<template>
    <!-- ============ PRICING START ============ -->
		<section id="pricing" class="text-center">
			<div class="container">
				<div class="row">
					<div class="col-sm-12">
						<h1>Planos &amp; Preços</h1>
						<h4>Participar é sempre gratuito. Ferramentas e visibilidade extra são opcionais e sempre identificadas</h4>
					</div>
				</div>
				<div class="row pricing">
					<div class="col-sm-3">
						<ul>
							<li class="title">Candidato</li>
							<li class="price">R$ 0,00</li>
							<li>Currículo completo, controlado por você</li>
							<li>Candidaturas ilimitadas, sempre gratuitas</li>
							<li>Sempre presente no resultado orgânico da busca</li>
							<li><a href="#/cadastrar_curriculo" class="btn btn-primary">Cadastrar Currículo</a></li>
						</ul>
					</div>
					<div class="col-sm-3">
						<ul class="popular">
							<li class="title">Workix Premium</li>
							<li class="price">Opcional</li>
							<li>Perfil em destaque na busca, sempre identificado</li>
							<li>Veja quem visualizou seu perfil e insights da vaga</li>
							<li>Contato direto com recrutadores, com créditos mensais</li>
							<li><a href="#/cadastrar_curriculo" class="btn btn-primary">Criar Perfil e Assinar</a></li>
						</ul>
					</div>
					<div class="col-sm-3">
						<ul>
							<li class="title">Empresa</li>
							<li class="price">R$ 0,00</li>
							<li>Publicação de vaga sempre gratuita, sem taxa</li>
							<li>Planos pagos ampliam vagas simultâneas e usuários</li>
							<li>Mesmo resultado orgânico, pago ou não</li>
							<li><a href="#/cadastrar_vaga" class="btn btn-primary">Publicar Vaga</a></li>
						</ul>
					</div>
					<div class="col-sm-3">
						<ul>
							<li class="title">Vaga em Destaque</li>
							<li class="price">Opcional</li>
							<li>Posição adicional na busca e no feed</li>
							<li>Sempre rotulada como "Patrocinada"</li>
							<li>Nunca substitui o resultado orgânico</li>
							<li><a href="#/cadastrar_vaga" class="btn btn-primary">Destacar uma Vaga</a></li>
						</ul>
					</div>
				</div>
			</div>
		</section>
		<!-- ============ PRICING END ============ -->
</template>

<script>
export default {

}
</script>

<style>

</style>